import { postDataAPI } from "../../utils/API";
import i18n from "../../i18n";
import { dialog } from "../../component/Common/TreasuryDialog";
import { postDataAPIBare } from "../../utils/API";
import GlobalTypes from "./GlobalTypes";
const t = (key) => i18n.t(key);

export const register = (data) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const res = await postDataAPI("register", data);
		if(res.data.status === 1){
			dialog.success(t("dialog.welcomeTitle"), t("dialog.registerSuccess"));
		}
		dispatch({
			type: GlobalTypes.AUTH,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err,
			},
		});
	}
};

export const login = (data) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const res = await postDataAPI("login", data);
		if(res.data.status === 1){
			dialog.success(t("dialog.welcomeBackTitle"), t("dialog.loginSuccess"));
		}
		dispatch({
			type: GlobalTypes.AUTH,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				// error: err.response.data.msg,
			},
		});
	}
};

export const adminLogin = (data) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const res = await postDataAPI("admin/login", data);
		if(res.data.status === 1){
			dialog.success(t("dialog.welcomeTitle"), t("dialog.loginSuccess"));
		}
		dispatch({
			type: GlobalTypes.AUTH,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				// error: err.response.data.msg,
			},
		});
	}
};

export const refreshToken = () => async (dispatch) => {
	try {
		// 5-second timeout prevents the splash screen from hanging on slow/mobile networks
		const res = await postDataAPI("refresh_token", undefined, undefined, 5000);
		dispatch({
			type: GlobalTypes.AUTH,
			payload: {
				data: res.data,
			},
		});
	} catch (err) {
		// Token refresh failed (no session, timeout, or network error) — treat as guest
		dispatch({ type: GlobalTypes.AUTH, payload: { data: null } });
	}
};

export const forgot_password = (data) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const res = await postDataAPIBare("forgot_password", data);

		dispatch({
			type: GlobalTypes.AUTH,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err.response.data.msg,
			},
		});
	}
};

export const updateProfile = (data) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const res = await postDataAPIBare("update_profile", data);

		dispatch({
			type: GlobalTypes.AUTH,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err.response.data.msg,
			},
		});
	}
};

export const updateProfilePic = (data) => async (dispatch, getState) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const res = await postDataAPIBare("update_profilePic", data);
		
		let response = res.data;
		if (response.status == 1) {
			dialog.success(t("dialog.updatedTitle"), t("dialog.profileImageUpdated"));
			// Merge the new profile_image into the existing auth.data state
			const currentAuth = getState().auth;
			const newProfileImage = response.data?.profile_image;
			if (newProfileImage && currentAuth.data) {
				dispatch({
					type: GlobalTypes.AUTH,
					payload: {
						...currentAuth,
						data: {
							...currentAuth.data,
							user: {
								...currentAuth.data.user,
								profile_image: newProfileImage,
							},
						},
					},
				});
			}
		}
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err?.response?.data?.msg || 'Upload failed',
			},
		});
	}
};

export const logout = () => async (dispatch) => {
	try {
		// Call backend to clear the refresh token cookie (best-effort)
		await postDataAPI("logout").catch(() => {});
	} finally {
		// Always clear Redux auth state so the UI reflects logged-out immediately
		dispatch({
			type: GlobalTypes.AUTH,
			payload: { data: { status: 0, action: "logout" } },
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: {} });
	}
};

export const loading = (data) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: data } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err.response.data.msg,
			},
		});
	}
};